import { IFormField } from "cayo.ui";
import { IObjectSelectionGrid } from "@cayo/shared/api/types/schema";

export interface IMember {
  distinguishedName: string;
  name: string;
  parentOU: string;
}

interface IAddedMember extends IMember {
  cayoObjId: string;
  newAddedFlag: boolean;
}

interface IRemovedMember extends IMember {}

export interface IMemberOfData {
  addedMembers: IAddedMember[];
  removedMembers: IRemovedMember[];
}

export interface IMembersLookupData {
  SearchScope: string;
  SearchString: string;
}

export const isObjectSelectionGrid = (i: IFormField): i is IObjectSelectionGrid =>
  i.type === "object-selection-grid";
